exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".aboutUs-root-3GhHi {\n  padding: 20px;\n  max-width: 1000px;\n  margin: 0 auto;\n}\n", ""]);

// exports
exports.locals = {
	"root": "aboutUs-root-3GhHi"
};